import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Fade from '@material-ui/core/Fade'; 
import Button from '@material-ui/core/Button/Button';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import Brightness3Icon from '@material-ui/icons/Brightness3';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  sleepProgress: {
    color: 'red',
    position: 'absolute',
    top: -6,
    left: -6,
    zIndex: 1,
  }
}));

export default function CircularIntegration(props) {
  const classes = useStyles();
  const [progress, setProgress] = useState(0);
  const [isRunning, setIsRunning] = useState(true);
  const [delay] = useState(150);
  const [disabled, setIsDisabled] = useState(false);
  const [unlocked, setIsUnlocked] = useState(false);
  
  const unlockVault = async (deviceId, firmware) => {    
    await window.AndroidInterface.unlockVault(deviceId,firmware);    
    setProgress(100);
    setIsDisabled(true);
    setIsUnlocked(true);
  };
  
    useInterval(() => {    
      setProgress(progress + 1);      
      if(progress === 100){
          setIsRunning(false);         
          setProgress(0); 
          setIsDisabled(true);           
      }
    }, isRunning ? delay : null);    

    return (                   
    
     <React.Fragment>                                                                     
          <Button size="medium" aria-label="unlock" 
                               startIcon={isRunning ? <VpnKeyIcon style={{ fontSize: 40 }} />  
                                                    : unlocked ? <VpnKeyIcon style={{ fontSize: 40,color:"green" }} /> : 
                                                    <Brightness3Icon style={{ fontSize: 40,color:"red" }} />} 
                               disabled={disabled}
                               onClick={() => unlockVault(props.deviceId,props.firmware)}>           
          {<Fade
                in={isRunning}
                style={{
                  transitionDelay: isRunning ? '800ms' : '0ms',
                }}
                unmountOnExit>
                 <CircularProgress size={72} className={classes.sleepProgress} variant="static" value={progress} />
            </Fade>}   
          </Button>                                      
        </React.Fragment>                               
    );
    
  } 

function useInterval(callback, delay) {
    const savedCallback = useRef();
  
    // Remember the latest function.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);
  
    // Set up the interval.
    useEffect(() => {
      function tick() {
        savedCallback.current();
      }
      if (delay !== null) {
        let id = setInterval(tick, delay);        
        return () => clearInterval(id);
      }
    }, [delay]);
}

  




// WEBPACK FOOTER //
// ./src/components/CountDown.js